import { TabletSmartphone } from "lucide-react";
import { ReactElement, useState } from "react";
import { Button } from "../ui/button";

const Unavailable4MobileError = ({
  originalElement,
}: {
  originalElement: ReactElement;
}) => {
  const [forceRender, setForceRender] = useState(false);

  return (
    <>
      {forceRender ? (
        originalElement
      ) : (
        <div className="flex flex-col gap-8 justify-center h-full -translate-y-1">
          <div className="flex flex-col gap-4">
            <div className="flex flex-row justify-center -translate-x-4">
              <TabletSmartphone size={192} />
            </div>
            <h1>Atenção</h1>
            <div className="flex flex-col gap-2">
              <p>Recomendamos acessar esta seção através de um computador.</p>
              <p>
                Esta funcionalidade ainda não está otimizada{" "}
                <span className="text-primary font-bold underline">
                  para dispositivos móveis.
                </span>
              </p>
            </div>
          </div>
          <Button onClick={() => setForceRender(true)}>
            Continuar mesmo assim
          </Button>
        </div>
      )}
    </>
  );
};

export default Unavailable4MobileError;
